import React from 'react';
import { ArrowLeft, Clock, CreditCard, Headset } from 'lucide-react';
import DashboardMockup from './DashboardMockup';

const FILES_BASE = process.env.REACT_APP_BACKEND_URL;

const TRUST_BADGES = [
  { icon: Clock, text: 'تجربة مجانية لمدة 30 يومًا' },
  { icon: CreditCard, text: 'دون بطاقة ائتمانية' },
  { icon: Headset, text: 'دعم فني عربي' },
];

export const LandingHero = ({ landing, navigate }) => {
  const overlayImage = landing?.hero_background_image
    ? (landing.hero_background_image.startsWith('http') ? landing.hero_background_image : `${FILES_BASE}/api/files/${landing.hero_background_image}`)
    : null;

  return (
    <section className="relative flex min-h-[92vh] items-center overflow-hidden" data-testid="landing-hero">
      <div className="absolute inset-0 bg-[#060f1c]">
        {overlayImage && <img src={overlayImage} alt="" className="h-full w-full object-cover opacity-25" />}
        <div
          className="absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage: 'linear-gradient(rgba(148,163,184,0.14) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.14) 1px, transparent 1px)',
            backgroundSize: '46px 46px',
            maskImage: 'radial-gradient(ellipse 80% 60% at 50% 30%, black 40%, transparent 100%)',
          }}
        />
        <div className="absolute -top-40 -end-40 h-[32rem] w-[32rem] rounded-full bg-teal-500/10 blur-3xl" />
        <div className="absolute -bottom-24 -start-24 h-96 w-96 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#060f1c] via-transparent to-[#060f1c]/40" />
      </div>

      <div className="relative z-10 mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-14 px-5 pt-24 pb-36 sm:pb-16 lg:gap-10 lg:pb-0 lg:grid-cols-2">
        <div className="max-w-2xl text-start">
          <span className="font-display inline-block rounded-full border border-teal-500/20 bg-teal-500/10 px-4 py-1.5 text-xs font-bold tracking-wide text-teal-400" data-testid="landing-hero-badge">
            {landing?.hero_badge_text || 'منصة SaaS لإدارة الأندية والأكاديميات الرياضية'}
          </span>
          <h1 className="font-display mt-6 text-4xl font-black leading-tight text-white sm:text-5xl lg:text-6xl" data-testid="landing-hero-title">
            {landing?.hero_title || 'أدر منشأتك الرياضية بذكاء'}
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg" data-testid="landing-hero-subtitle">
            {landing?.hero_subtitle || 'تسيار منصة متكاملة لإدارة الأندية والأكاديميات الرياضية، تجمع اللاعبين والاشتراكات والفرق والموظفين والحضور والمالية والتدريب والتقارير في مكان واحد.'}
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <button
              onClick={() => navigate('/register')}
              className="group flex items-center justify-center gap-2 rounded-full bg-gradient-to-l from-orange-500 to-orange-400 px-8 py-4 text-base font-bold text-white shadow-[0_0_30px_rgba(245,76,7,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_0_40px_rgba(245,76,7,0.55)]"
              data-testid="landing-hero-cta"
            >
              {landing?.hero_cta_text || 'ابدأ تجربتك المجانية'}
              <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
            </button>
            <button
              onClick={() => navigate('/login')}
              className="flex items-center justify-center rounded-full border border-white/20 px-8 py-4 text-base font-bold text-white transition-colors hover:border-white/50 hover:bg-white/10"
              data-testid="landing-hero-secondary-cta"
            >
              {landing?.hero_cta_secondary_text || 'تسجيل الدخول'}
            </button>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-slate-400 sm:text-sm" data-testid="landing-hero-trust-line">
            {TRUST_BADGES.map((b, i) => (
              <span key={i} className="flex items-center gap-1.5">
                <b.icon className="h-3.5 w-3.5 text-teal-400" />
                {b.text}
                {i < TRUST_BADGES.length - 1 && <span className="mx-2 text-slate-600">•</span>}
              </span>
            ))}
          </div>
        </div>

        <div className="hidden lg:block">
          <DashboardMockup />
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
